import * as h2Api from '../../h2Api'
import * as profilerActions from '../../actions/earlyInterestActivity'
import * as earlyListingActions from '../../actions/early/earlyListing'

const initialState = {
  metaData: {
    questions: []
  },
  answers: {}, // map of questionId -> answerId
  //  When currentQuestionIndex is -1, the user is shown an introductory page
  currentQuestionIndex: -1,
  results: []
}
const dirPrefix = '/images/common/earlyexploration/'
const questions = [
  { img: `${dirPrefix}Realistic/p1.svg`, interestType: '1.B.1.a', id: 'r1' },
  { img: `${dirPrefix}Investigative/p1.svg`, interestType: '1.B.1.b', id: 'i1' },
  { img: `${dirPrefix}Artistic/p1.svg`, interestType: '1.B.1.c', id: 'a1' },
  { img: `${dirPrefix}Social/p1.svg`, interestType: '1.B.1.d', id: 's1' },
  { img: `${dirPrefix}Enterprising/p1.svg`, interestType: '1.B.1.e', id: 'e1' },
  { img: `${dirPrefix}Conventional/p1.svg`, interestType: '1.B.1.f', id: 'c1' },
  { img: `${dirPrefix}Realistic/p2.svg`, interestType: '1.B.1.a', id: 'r2' },
  { img: `${dirPrefix}Investigative/p2.svg`, interestType: '1.B.1.b', id: 'i2' },
  { img: `${dirPrefix}Artistic/p2.svg`, interestType: '1.B.1.c', id: 'a2' },
  { img: `${dirPrefix}Social/p2.svg`, interestType: '1.B.1.d', id: 's2' },
  { img: `${dirPrefix}Enterprising/p2.svg`, interestType: '1.B.1.e', id: 'e2' },
  { img: `${dirPrefix}Conventional/p2.svg`, interestType: '1.B.1.f', id: 'c2' }
]
const sampleQuestionnaire = {
  data: questions,
  questions: [
    {
      id: 'q1',
      choices: ['r1', 'i1']
    },
    {
      id: 'q2',
      choices: ['i1', 'a1']
    },
    {
      id: 'q3',
      choices: ['a1', 's1']
    },
    {
      id: 'q4',
      choices: ['s1', 'e1']
    },
    {
      id: 'q5',
      choices: ['e1', 'c1']
    },
    {
      id: 'q6',
      choices: ['c1', 'r2']
    },
    {
      id: 'q7',
      choices: ['r2', 'e2']
    },
    {
      id: 'q8',
      choices: ['e2', 'i2']
    },
    {
      id: 'q9',
      choices: ['i2', 's2']
    },
    {
      id: 'q10',
      choices: ['s2', 'c2']
    },
    {
      id: 'q11',
      choices: ['c2', 'a2']
    }
  ]
}
const initialState4Test = {
  ...initialState,
  metaData: sampleQuestionnaire,
  results: []
}
const earlyInterestActivity = (state = initialState4Test, action) => {
  switch (action.type) {
    case earlyListingActions.LOAD_GAME:
      console.log(action.restCall.result)

      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        return {
          ...state,
          ...action.restCall.result.interestActivity
        }
      }

      return state

    case profilerActions.PROFILER_LOAD:
      console.log(state)

      return {
        ...state,
        currentQuestionIndex: parseInt(action.selected)
      }

    case profilerActions.PROFILER_MOVE:
      console.log(state)

      if (action.questionIndex < 0) {
        return state
      }

      return {
        ...state,
        currentQuestionIndex: action.questionIndex
      }

    case profilerActions.PROFILER_SELECT_CHOICE:
      var newState = {
        ...state,
        currentQuestionIndex: parseInt(state.currentQuestionIndex) + 1,
        answers: {
          ...state.answers,
          [action.question.id]: action.choice.interestType
        }
      }
      const completedAt =
        Object.keys(newState.answers).length >= newState.metaData.questions.length
          ? new Date()
          : null

      return {
        ...newState,
        completedAt
      }

    case profilerActions.PROFILER_RESET:
      return {
        ...state,
        answers: {},
        results: [],
        completedAt: null,
        currentQuestionIndex: -1
      }

    case profilerActions.PROFILER_SCORE:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        return {
          ...state,
          results: action.restCall.result
        }
      }

      return state

    default:
      return state
  }
}

export default earlyInterestActivity
